import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { CalendarAngularDateFormatter, DateFormatterParams } from 'angular-calendar';

/**
 * angular-calendar formats the week view column headers with US patterns ("oct 19"); the rest of the calendar reads
 * day first in Spanish, so the headers do too ("19 oct").
 */
@Injectable()
export class SpanishCalendarDateFormatter extends CalendarAngularDateFormatter {
  override weekViewColumnSubHeader({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'd MMM', locale ?? 'es');
  }
}
